module.exports = __webpack_public_path__ + "img/img2-2.74513637.png";